var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRowReject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18.643px",
    height: "14.915px",
    viewBox: "0 0 18.643 14.915",
    enableBackground: "new 0 0 18.643 14.915",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-times",
    fill: "#707070",
    d: "M17.176,6.991L18.5,5.663c0.184-0.183,0.184-0.48,0-0.663l-0.664-0.664 c-0.183-0.183-0.479-0.184-0.663,0c0,0,0,0-0.001,0l-1.324,1.327l-1.328-1.328c-0.184-0.183-0.48-0.184-0.663,0 c-0.001,0-0.001,0-0.001,0L13.19,5c-0.184,0.183-0.184,0.48-0.001,0.663c0,0,0.001,0,0.001,0.001l1.328,1.328L13.19,8.32 c-0.184,0.183-0.184,0.479-0.001,0.663l0.001,0.001l0.664,0.664c0.183,0.184,0.479,0.184,0.663,0.001c0,0,0,0,0.001-0.001 l1.329-1.328l1.327,1.328c0.184,0.184,0.48,0.184,0.664,0.001c0,0,0,0,0-0.001l0.664-0.664c0.184-0.183,0.184-0.479,0.001-0.663 c0,0,0,0-0.001-0.001L17.176,6.991z M6.526,7.457c2.06,0.001,3.73-1.667,3.731-3.726C10.26,1.671,8.592,0,6.532-0.001 S2.802,1.666,2.8,3.725c0,0.001,0,0.002,0,0.004C2.8,5.787,4.467,7.457,6.526,7.457L6.526,7.457z M9.136,8.389H8.649 c-1.348,0.621-2.899,0.621-4.247,0H3.915c-2.16,0-3.912,1.75-3.915,3.91v1.213c0,0.773,0.627,1.4,1.4,1.4h10.252 c0.773,0,1.399-0.627,1.399-1.4v-1.213c-0.003-2.16-1.756-3.91-3.917-3.909L9.136,8.389z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowReject);
export default __webpack_public_path__ + "static/media/row-reject.a4d347efff3e2d7fe86d38cdcbe80aa3.svg";
export { ForwardRef as ReactComponent };